import { Grid, Typography } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import PSelect from "../../../components/pos/PSelect";
import { useTranslation } from "react-i18next";
import CustomerAccountingCrud2 from "./CustomerAccountingCrud2";

export default function CustomerAcctpaymentTypeSelector(props) {
  const [windowTitle, setWindowTitile] = useState("");
  const [openWindow, setOpenWindow] = useState(false);
  const [transactionMode, setTransactionMode] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [showCrud, setShowCrud] = useState(false);
  const [paymentTypeError, setPaymentTypeError] = useState("");
  const [liveValidation, setLiveValidation] = useState(false);
  const { t } = useTranslation();
  const translate = t;

  function validate() {
    let flag = true;
    if (!paymentType || paymentType === "") {
      setPaymentTypeError(translate("Payment type is required"));
      flag = false;
    }
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  useEffect(() => {
    if (liveValidation && paymentType === "") {
      setPaymentTypeError(translate("Payment type is required"));
    } else {
      setPaymentTypeError("");
    }
  }, [paymentType]);

  props.biRef.child = {
    showCustomerAccountingPaymentType: showCustomerAccountingPaymentType,
  };

  function resetFields() {
    setPaymentType("");
    setPaymentTypeError("");
  }

  function showCustomerAccountingPaymentType(transMode, transactionsId) {
    setPaymentTypeError("");
    setOpenWindow(true);
    setWindowTitile("Receipt method");
    if (transMode === "Cash") {
      setTransactionMode("Cash");
    } else {
      setTransactionMode("Bank");
    }
  }

  function onCloseWindow() {
    resetFields();
    setOpenWindow(false);
  }

  function handlePaymentTypeChange(value) {
    setPaymentType(value);
  }

  function onContinueClicked() {
    if (validate()) {
      setShowCrud(true);
    }
  }

  var biRef = {};

  const content = (
    <div>
      <Grid container spacing={1}>
        <Grid item sm={10}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">Mode</Typography>
                </td>
                <td>
                  <Typography variant="body1">
                    {transactionMode} receipt
                  </Typography>
                </td>
              </tr>
              <tr>
                <td style={{ width: 100 }}>
                  <Typography variant="body1">Receipt type</Typography>
                </td>
                <td style={{ width: 180 }}>
                  <PSelect
                    options={[
                      { id: 1, name: "Invoice against" },
                      { id: 2, name: "Own account" },
                      { id: 3, name: "Advance receipt" },
                      { id: 4, name: "Partial receipt" },
                    ]}
                    value={paymentType}
                    errorMessage={paymentTypeError}
                    placeholder={"Select..."}
                    onChange={(event, newValue) => {
                      handlePaymentTypeChange(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );
  function closeParentWindow() {
    console.log("closeParentWindow called");
    resetFields();
    setOpenWindow(false);
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          hideSave={false}
          saveLabel="Continue"
          onCloseWindow={onCloseWindow}
          onSave={onContinueClicked}
        ></PDialog>
      )}
      {showCrud && (
        <CustomerAccountingCrud2
          showCrud={props.showCrud}
          transactionMode={transactionMode}
          paymentType={paymentType}
          showMessage={props.showMessage}
          setAlert={props.setAlert}
          context={props.context}
          setShowCrud={setShowCrud}
          closeParentWindow={closeParentWindow}
          onRefresh={props.onRefresh}
          showProgress={props.showProgress}
          hideProgress={props.hideProgress}
        ></CustomerAccountingCrud2>
      )}
    </div>
  );
}
